import script from "./OtpValidation.vue?vue&type=script&setup=true&lang=js"
export * from "./OtpValidation.vue?vue&type=script&setup=true&lang=js"

import "./OtpValidation.vue?vue&type=style&index=0&id=0438f822&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0438f822"]])

export default __exports__